import React from 'react';

const Breadcumbs = ({ jmlLevel, menuLevel1, menuLevel2, menuLevel3, menuLevel4, menuLevel5 }) => {
  return (
    <>
      {
        jmlLevel === 1 ? (
          <p className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
            {`${menuLevel1}`}
          </p>
        ) : jmlLevel === 2 ? (
          <>
            <p>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
                {`${menuLevel1} > `}
              </span>
              <span className=' font-sans text-black-300 font-semibold leading-[19.07px] text-sm'>
              {`${menuLevel2}`}
              </span>
            </p>
          </>
        ) : jmlLevel === 3 ? (
          <>
            <p>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
                {`${menuLevel1}`}
              </span>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
              {` > ${menuLevel2} > `}
              </span>
              <span className=' font-sans text-black-300 font-semibold leading-[19.07px] text-sm'>
              {`${menuLevel3}`}
              </span>
            </p>
          </>
        ) : jmlLevel === 4 ? (
          <>
            <p>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
                {`${menuLevel1}`}
              </span>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
              {` > ${menuLevel2}`}
              </span>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
              {` > ${menuLevel3} > `}
              </span>
              <span className=' font-sans text-black-300 font-semibold leading-[19.07px] text-sm'>
              {`${menuLevel4}`}
              </span>
            </p>
          </>
        ) : jmlLevel === 5 ? (
          <>
            <p>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
                {`${menuLevel1}`}
              </span>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
              {` > ${menuLevel2}`}
              </span>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
              {` > ${menuLevel3}`}
              </span>
              <span className=' font-sans text-black-300 font-normal leading-[19.07px] text-sm'>
              {` > ${menuLevel4} > `}
              </span>
              <span className=' font-sans text-black-300 font-semibold leading-[19.07px] text-sm'>
              {`${menuLevel5}`}
              </span>
            </p>
          </>
        ) : null
      }
    </>
  );
}

export default Breadcumbs;